import { render, staticRenderFns } from "./JournalDialog.vue?vue&type=template&id=23378446"
import script from "./JournalDialog.vue?vue&type=script&lang=ts"
export * from "./JournalDialog.vue?vue&type=script&lang=ts"
import style0 from "./JournalDialog.vue?vue&type=style&index=0&id=23378446&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports